import { studentsRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN];

const studentsRouteMetadata: IRouteMetadataObj<typeof studentsRoutesObj> = {
  create: {
    title: "users.student.create.title",
    description: "users.student.create.description",
    lazy: () => import("@/pages/userManagement/students/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "users.student.edit.title",
    description: "users.student.edit.description",
    lazy: () => import("@/pages/userManagement/students/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
};

export const studentsRoutes = createRoute<typeof studentsRoutesObj>(
  studentsRoutesObj,
  studentsRouteMetadata,
);
